module.exports = __webpack_public_path__ + "static/media/bg-welcome2.70ec9a6c.webp";